
<div class="page-container">
  <app-header></app-header>
  <div class="content">
    <!-- <img src="../../assets/images/termandcon.jpg" alt="About Us"
      class="aboutus"> -->
          <div
      class="aboutus"></div>
    <!-- <div *ngIf="termAndConditionContent" [innerHTML]="termAndConditionContent" class="aboutus-container"></div> -->
    <div class="container py-2">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="card shadow-lg rounded">
            <div class="card-body">
              <h1 class="text-start mb-2">Terms and Conditions</h1>
              <p class=" text-start mb-4">Effective Date:
                10-02-2025</p>
              <p class=" text-start mb-4">Website: <a
                  href="mailto:fuprop.com"
                  style="color: #004aad; text-decoration: none;">www.fuprop.com</a>
              </p>
              <h3>Introduction</h3>
              <p>Welcome to fuprop.com ("FuProp", “we”, “our”, “us").
                These Terms & Conditions ("Terms") govern your use of our
                website, mobile applications, and all related services
                (collectively, the “Platform”). By accessing or using our
                Platform, you agree to be legally bound by these Terms.</p>
              <p>If you do not agree with these Terms, please do not use our
                services.</p>

              <h3>Eligibility</h3>
              <ul>
                <li>Be at least 18 years old</li>
                <li>Have the legal capacity to enter into contracts</li>
                <li>Use the Platform in compliance with all applicable laws and
                  regulations</li>
              </ul>

              <h3>Platform Role</h3>
              <p>FuProp is a technology service provider offering a platform
                for users to:</p>
              <ul>
                <li> List, browse, and discover real estate properties for sale
                  or rent</li>
                <li> Communicate and negotiate with other users</li>
                <li>Upload and share real estate-related contracts and
                  documents</li>
              </ul>
              <p>FuProp is not a party to any property transaction and does
                not provide legal, financial, or brokerage services unless
                explicitly stated.</p>

              <h3>User Responsibilities</h3>
              <ul>
                <li> Provide accurate and truthful information during
                  registration and listing</li>
                <li> Use the Platform solely for lawful purposes</li>
                <li> Not impersonate another person or misrepresent ownership of
                  property</li>
                <li> Maintain the confidentiality of your account
                  credentials</li>
                <li> Be fully responsible for all activity under your
                  account</li>
              </ul>

              <h3>Property Listings</h3>
              <p>When posting a property, you agree that:</p>
              <ul>
                <li> You have the legal right to list and offer the
                  property</li>
                <li> All details (price, description, ownership) are accurate
                  and up to date</li>
                <li> You will not post false, misleading, or duplicate
                  listings</li>
                <li> You are responsible for any legal or tax obligations
                  resulting from your listing or transaction</li>
              </ul>

              <h3>Document and Contract Sharing</h3>
              <p>The Platform does not allow users to upload and share
                property-related contracts or documents.</p>
              <ul>
                <li> Only the involved parties will have access to these
                  documents</li>
                <li> FuProp acts as a secure medium, not as a signatory or
                  validator</li>
                <li> Users are solely responsible for the content, validity, and
                  enforcement of any shared documents</li>
              </ul>

              <h3>Intellectual Property</h3>
              <ul>
                <li> All content, branding, software, and technology on FuProp
                  are the intellectual property of FuProp or its
                  licensors.</li>
                <li> Users may not copy, modify, distribute, or use any content
                  without prior written consent.</li>
              </ul>

              <h3>Prohibited Activities</h3>
              <ul>
                <li> Upload unlawful, fraudulent, or harmful content</li>
                <li> Infringe on intellectual property rights</li>
                <li> Use bots or automated scripts to scrape or manipulate
                  data</li>
                <li> Post duplicate, spam, or misleading listings</li>
                <li> Harass, threaten, or abuse other users</li>
              </ul>

              <h3>Disclaimer of Liability</h3>
              <p>The Platform is provided "as is" and "as available" without
                warranties of any kind. We do not guarantee:</p>
              <ul>
                <li> That listings are accurate or complete</li>
                <li> That any transaction will be successful or profitable</li>
                <li> That uploaded documents are legal or enforceable</li>
                <li> That the Platform will always be error-free or secure</li>
              </ul>

              <h3>Indemnification</h3>
              <p>You agree to indemnify and hold harmless FuProp, its
                directors, employees, and affiliates from any claims, losses, or
                damages arising out of:</p>
              <ul>
                <li> Your use of the Platform</li>
                <li>Your violation of these Terms</li>
                <li> Your interactions or disputes with other users</li>
                <li>Your uploaded content or contracts</li>
              </ul>

              <h3>Account Termination</h3>
              <p>We may suspend or terminate your account:</p>
              <ul>
                <li> For breach of these Terms</li>
                <li> If required by law or regulatory authorities</li>
                <li> If your behavior compromises the safety or integrity of the
                  Platform</li>
              </ul>
              <p>You may delete your account at any time by contacting

                <a href="mailto:support@fuprop.com"
                  style="color: #004aad; text-decoration: none;">support@fuprop.com</a>.</p>

              <h3>Governing Law and Jurisdiction</h3>
              <p>These Terms are governed by the laws of India, and any disputes
                shall be subject to the exclusive jurisdiction of the courts in
                Gurugram, Haryana, India.</p>

              <h3>Amendments</h3>
              <p>We reserve the right to modify these Terms at any time. We will
                notify users of significant changes through the Platform or via
                email. Continued use after changes implies acceptance.</p>

              <h3>Contact Us</h3>
              <p>For any questions, clarifications, or complaints related to
                these Terms, please contact:</p>
              <p>Email: <a
                  href="mailto:support@fuprop.com"  style="color: #004aad; text-decoration: none;">support@fuprop.com</a></p>
              <p>Phone: +91 7838656543</p>
              <p>Address: ANS Greens, Unit-103, Plot 478, Krishna Colony,
                Gurugram, Haryana, India – 122001</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <app-footer></app-footer>
</div>
